<h2 class="terra-headline-3 section-heading">{{ sectionTitle }}</h2>

@if (isEos) {
  <p class="terra-body section-desc">
    Select Yes or No for each regarding
    <strong>{{ discussion.manager | userName }}</strong>
    .
  </p>
} @else {
  <p class="terra-body section-desc">
    Select Yes, No, or Maybe for each regarding
    <strong>{{ discussion.manager | userName }}</strong>
    .
  </p>
}

<ion-list [formGroup]="form">
  @for (ctrl of managerRatingsCtrls; track ctrl; let i = $index) {
    <ng-template #titleTemplate>{{ getCommitmentTitle(i) }}</ng-template>

    <div class="commitment-title-with-tooltip-container">
      <h3 class="terra-title-small section-question-heading">
        <ng-container *ngTemplateOutlet="titleTemplate" />
      </h3>

      <ion-button size="small" fill="outline" class="tooltip-btn" [ntyBottomSheet]="tooltipContent" [modalHeight]="0.5">
        <ion-icon slot="icon-only" name="information-outline" />
      </ion-button>
    </div>

    <ng-template #tooltipContent>
      <h3 class="terra-headline-3 tooltip-content-heading">
        <ng-container *ngTemplateOutlet="titleTemplate" />
      </h3>

      <ul class="commitment-tooltip-list">
        @for (item of getCommitmentItems(i); track item) {
          <li class="terra-body">{{ item.label }}</li>
        }
      </ul>
    </ng-template>

    @if (isMeeting || isManager) {
      @if (isMeeting) {
        <p>{{ discussion.manager | userName }}</p>
      }

      <ion-segment [formControl]="ctrl">
        <ion-segment-button [value]="CommitmentRating.YES" [disabled]="ctrl.disabled" class="positive">
          <div class="segment-button-inner">
            @if (ctrl.value === CommitmentRating.YES) {
              <ion-icon name="checkmark-outline" class="segment-icon" />
            }
            <span>Yes</span>
          </div>
        </ion-segment-button>
        @if (!isEos) {
          <ion-segment-button [value]="CommitmentRating.MAYBE" [disabled]="ctrl.disabled" class="neutral">
            <div class="segment-button-inner">
              @if (ctrl.value === CommitmentRating.MAYBE) {
                <ion-icon name="help-outline" class="segment-icon" />
              }
              <span>Maybe</span>
            </div>
          </ion-segment-button>
        }
        <ion-segment-button [value]="CommitmentRating.NO" [disabled]="ctrl.disabled" class="negative">
          <div class="segment-button-inner">
            @if (ctrl.value === CommitmentRating.NO) {
              <ion-icon name="close-outline" class="segment-icon" />
            }
            <span>No</span>
          </div>
        </ion-segment-button>
      </ion-segment>
    }

    @if (isMeeting || isManagee) {
      @if (isMeeting) {
        <p>{{ discussion.managee | userName }}</p>
      }

      <ion-segment [formControl]="manageeRatingsCtrls[i]">
        <ion-segment-button [value]="CommitmentRating.YES" class="positive">
          <div class="segment-button-inner">
            @if (manageeRatingsCtrls[i].value === CommitmentRating.YES) {
              <ion-icon name="checkmark-outline" class="segment-icon" />
            }
            <span>Yes</span>
          </div>
        </ion-segment-button>
        @if (!isEos) {
          <ion-segment-button [value]="CommitmentRating.MAYBE" class="neutral">
            <div class="segment-button-inner">
              @if (manageeRatingsCtrls[i].value === CommitmentRating.MAYBE) {
                <ion-icon name="help-outline" class="segment-icon" />
              }
              <span>Maybe</span>
            </div>
          </ion-segment-button>
        }
        <ion-segment-button [value]="CommitmentRating.NO" class="negative">
          <div class="segment-button-inner">
            @if (manageeRatingsCtrls[i].value === CommitmentRating.NO) {
              <ion-icon name="close-outline" class="segment-icon" />
            }
            <span>No</span>
          </div>
        </ion-segment-button>
      </ion-segment>
    }
  }
</ion-list>

@if (isMeeting || isManager) {
  <nty-textarea
    [formControl]="form.controls.manager.controls.notes"
    [label]="managerCommentLabel"
    placeholder="Enter text" />
}

@if (isMeeting || isManagee) {
  <nty-textarea
    [formControl]="form.controls.managee.controls.notes"
    [label]="manageeCommentLabel"
    placeholder="Enter text" />
}
